// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__znFTG","title":"styles_title__r6vWT","text":"styles_text__CLPAL"};